const retryFetch = require("../../utils/retry-fetch");

const securemaBaseUrl = CONFIG.securemaBaseUrl;
const market = CONFIG.iowsLocale;
const language = CONFIG.language;

const addToNewList = (payload) => {
  
  const productPostDataPayload = postPayload({
    userId: payload.session.userId,
    bagName: payload.listName,
    itemType: payload.productType,
    itemNo: payload.productNumber,
    itemQty: payload.quantity,
  });

  const requestObject = getRequestObject({
    userId: payload.session.userId,
    payload: productPostDataPayload,
  });

  return retryFetch(3, 1000)(requestObject.url, requestObject)
    .then(() => ({ status: "LIST_ADD_SUCCESS" }))
    .catch(() => ({ status: "LIST_ADD_FAIL" }));
};

const getRequestObject = (state) => {
  
  return {
    method: "POST",
    headers: {
      Accept: "application/vnd.middleware-v1+json",
      Contract: CONFIG.iowsApiContract,
      Consumer: CONFIG.iowsApiConsumer,
      "Content-type": "application/json",

    },
    url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppinglist`,
    mode: "cors",
    cache: "default",
    credentials: "include",
    body:JSON.stringify(state.payload),
  };
};

const postPayload = ({ userId, itemType, itemNo, itemQty, bagName }) => ({
  BagType: "onlineshoppinglist",
  BagSource: "M2",
  BagName: bagName,
  CustomerSource: "M2",
  CustomerId: userId,
  CreatedDateTime: new Date().toUTCString(),
  shoppingBagSectionList: [
    {
      shoppingBagItemList: [
        {
          itemType: itemType.toUpperCase(),
          itemNo: itemNo,
          itemQty: itemQty,
        },
      ],
    },
  ],
  // "@xmlns": { $: "ikea.com/cem/iows/ShoppingBagService/2.0/" },
});

module.exports = addToNewList;
